import React from 'react';
import PropTypes from 'prop-types';

const SVG = ({ height, width, className, viewBox, enableBackground }) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    enableBackground={enableBackground}
    className={`svg-icon ${className || ''}`}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
  >
    <path
      fill="#4BE387"
      d="M61,30.5C61,47.346,47.346,61,30.5,61C13.655,61,0,47.346,0,30.5C0,13.655,13.655,0,30.5,0
	C47.346,0,61,13.655,61,30.5"
    />
    <path
      fill="#0D1C70"
      d="M30.921,14.019c-2.871,0-5.546,0.854-7.953,2.538c-1.058,0.742-2.004,1.6-2.833,2.568V15.96
	c0-1.143-0.785-1.941-1.91-1.941c-1.143,0-1.941,0.798-1.941,1.941v27.668c0,1.144,0.798,1.94,1.941,1.94
	c1.125,0,1.91-0.797,1.91-1.94V29.801c0.018-3.337,1.065-6.103,3.198-8.454c2.121-2.319,4.603-3.447,7.588-3.447
	c2.963,0,5.437,1.128,7.558,3.447c2.151,2.352,3.196,5.115,3.196,8.447v13.834c0,1.144,0.787,1.94,1.912,1.94
	c1.143,0,1.94-0.797,1.94-1.94V29.794c0-4.306-1.435-8.044-4.259-11.107C38.434,15.59,34.951,14.019,30.921,14.019"
    />
  </svg>
);

SVG.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  className: PropTypes.string,
  viewBox: PropTypes.string,
  enableBackground: PropTypes.string
};

SVG.defaultProps = {
  height: '61px',
  width: '61px',
  className: 'nevidis',
  viewBox: '0 0 61 61',
  enableBackground: 'new 0 0 61 61'
};

export default SVG;
